import React, { Fragment } from 'react';

const HistoryList = (props) => (
    <Fragment>
        <div className="row">
            <div className="col-lg-12">
                <div className="panel panel-white">
                    <table className="table table-togglable table-hover table-bordered table-striped">
                        <thead className="grey-light">
                            <tr>
                                <th
                                    className="text-center"
                                    data-hide="phone"
                                    style={{ width: '100px' }}
                                >
                                    Ngày tạo
                                </th>
                                <th
                                    className="text-center"
                                    data-toggle="true"
                                    style={{ width: '15%' }}
                                >
                                    Mã đơn hàng
                                </th>
                                <th className="text-center" data-hide="phone">
                                    Ghi chú
                                </th>

                                <th
                                    className="text-center"
                                    style={{ width: '8%' }}
                                >
                                    Tổng tiền
                                </th>
                                <th
                                    className="text-center"
                                    style={{ width: '8%' }}
                                    data-hide="phone,tablet"
                                >
                                    Tình trạng
                                </th>
                                <th
                                    className="text-center"
                                    style={{ width: '80px' }}
                                    data-hide="phone,tablet"
                                >
                                    Hành động
                                </th>
                            </tr>
                        </thead>
                        <tbody>{props.children}</tbody>
                    </table>
                </div>
            </div>
        </div>
    </Fragment>
);

export default HistoryList;
